/**
 * @flow
 */
'use strict';

export const chiefComplaintCodes = [
{"code":"Flashes of light"},
{"code":"Floaters"},
{"code":"Blurry vision near"},
{"code":"Blurry vision far"},
{"code":"Dry eye"},
{"code":"Watery eye"},
{"code":"Burning sensation"},
{"code":"Difficulty seeing at night"},
{"code":"Dilated pupils"},
{"code":"Excessive tearing"},
{"code":"Failed school vision test"},
{"code":"Gritty sensation"},
{"code":"Headaches"},
{"code":"Irritation"},
{"code":"Itching sensation"},
{"code":"Loss of vision"},
{"code":"Pain"},
{"code":"Sandy sensation"},
{"code":"Sensitivity to light"},
]
